<template>
    <v-card class="ma-3">
        <v-card-title>{{ reply.field.title }}</v-card-title>
        <v-card-subtitle>{{ reply.field.description }}</v-card-subtitle>
        <v-card-text v-html="reply.field.html.content" />
    </v-card>
</template>

<script>
    export default {
        name: "FieldHtmlReply",
        props: {
            reply: {type: Object, default: () => {}}
        },
    }
</script>

<style scoped>

</style>